import * as fb from '../../firebase'
import * as firebase from 'firebase/app'

export default {
  namespaced: true,
  state:{
    currentDate: '',
    dailies: {},
    dailylist: [],
  },

  /* ================================================================ */
  mutations: {
    setCurrentDate(state, val) {
      state.currentDate = val;
    },
    resetDailyItems(state) {
      state.dailies={}
    },
    /**
     * 
     * @param {*} state 
     * @param {*} items 
     */
    setDailyItems(state, payload) {
      if (!payload) { return }
      if (payload['key']) {
        state.dailies[payload['key']] = payload['data']
      }
      else if(payload.data){
        state.dailies =payload.data
      }
      
      if (payload.id) {
        state.dailies['docID'] = payload.id;
      }
    },
    /**
     * 
     * @param {*} state 
     * @param {*} dates 
     */
    setDailyItemsList(state, payload) {
      if (!payload) { return }
      state.dailylist = payload;
      state.dailylist.sort().reverse()
    },

    updateDailyItemsList(state, payload) {
      if (payload.todo == 'add') {
        //For recurrent schedule
        if (Array.isArray(payload.date)) {
          const items = payload['date'].filter(item => state.dailylist.find(date => date == item))

          state.dailylist=state.dailylist.concat(items)
        }
        else {
          if (!state.dailylist.includes(payload.date)) {
            state.dailylist.push(payload.date)
          }
        }
        //Sort dates in descendant chronological order
        state.dailylist.sort().reverse()
      }
      else if (payload.todo == 'delete') {
        //Delete one item at a time
        state.dailylist = state.dailylist.filter(item => item != payload.date);
      }
    }

  },

  /* ======================================================================== */
  /* ======================================================================== */
  actions: {
    async resetDailyItems({commit}) {
      commit('resetDailyItems')
    },

  /* ---------------------------------------------------------------- */
    async saveDailyItems({ state, dispatch, commit }, payload) {
      console.log('Payload:', payload)
      //
      if (state.dailies[payload.key]) {
        dispatch('updateDailyItems', payload)
        return;
      }

      await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc(payload.date).set({[payload.key]: payload.data}, {merge: true})
        .then(() => {
          //Save the document ID
          if (!state.dailies.docID){
            dispatch('saveDailyItemsList', {date: payload.date})
          }
          commit('setDailyItems', {key:payload.key, id:payload.date, data: payload.data});
        })
        .catch(error => {
          console.log('An error has occurred:', error)
        });
    },

    /**
     * Update existing document field
     */
    async updateDailyItems({ commit }, payload) {
      await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc(payload.date).update({[payload.key]: payload.data})
        .then(() => {
          commit('setDailyItems', {key: payload.key, id:payload.date, data: payload.data});
        })
        .catch(error => {
          console.log('An error has occurred:', error)
        });
    },

  /* ---------------------------------------------------------------- */
    async saveDailySchedule({dispatch, commit }, payload) {
      const batch = firebase.firestore().batch();
      const docRefs = [];
      
      for (var i = 0; i < payload['recurrencedates'].length; i++) {
        docRefs[i] = fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc(payload['recurrencedates'][i]);
        batch.set(docRefs[i], { [payload.key]: payload.data }, { merge: true })
      }

      batch.commit().then(() => {
        dispatch('saveDailyItemsList', payload)
        commit('setDailyItems', { ...payload, id: payload.date })
      }).catch(error => {
        console.log('An error has occurred:', error)
      });
    },

  /* ---------------------------------------------------------------- */
    async fetchDailyItems({ commit }, payload) {
      await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc(payload.date).get().then(doc => {
        if (doc.exists) {
          commit('setDailyItems', { id: doc.id, data: doc.data() })
        }
        else {
          commit('setDailyItems', {})
        }
      }).catch((error => {
        console.log("Error getting document:", error);
      }));
    },

  /* ---------------------------------------------------------------- */
  async saveDailyItemsList({ state, dispatch }, payload) {
    if (state.dailylist.length>0) {
      dispatch('updateDailyItemsList', payload)
      return;
    }

    await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc('dailieslist').get()
      .then(doc => {
        if (doc && doc.exists) {
          dispatch('updateDailyItemsList', payload)
        }
        else {
          dispatch('createDailyItemsList', payload)
        }
      })
      .catch(error => {
        console.log('Error while retrieving dailies list', error.message)
    })
  },

  /* ---------------------------------------------------------------- */
    async createDailyItemsList({ commit }, payload) {
      console.log('About to save dailieslist')
      //No "dailylist" exists yet
      const recurrencedates = payload.recurrencedates || [payload.date];

      await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc('dailieslist').set({ dates: recurrencedates})
        .then(() => {
          commit('updateDailyItemsList', { date: recurrencedates, todo: 'add' })
        })
        .catch(error => {
          console.log('Error saving daily items list:', error)
        })
    },

  /* ---------------------------------------------------------------- */
    async updateDailyItemsList({ commit }, payload) {
      console.log('About to update dailieslist')
      const recurrencedates = payload.recurrencedates || [payload.date];

      await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc('dailieslist').update({ dates: firebase.firestore.FieldValue.arrayUnion(...recurrencedates) })
        .then(() => {
          commit('updateDailyItemsList', { date: recurrencedates, todo: 'add' })
        })
        .catch(error => {
          console.log('Error updating daily items list:', error)
        })
    },

  /* ---------------------------------------------------------------- */
    async fetchDailyItemsList({state, commit }) {
      //Daily Items List already fetched
      if (state.dailylist.length > 1) { return; }
      
      await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc('dailieslist').get()
        .then(function (querySnapshot) {
          commit('setDailyItemsList', querySnapshot.data()['dates'])
        })
        .catch(error => {
          console.log('Error retrieving daily list items:', error)
      })
    },

  /* ---------------------------------------------------------------- */
    async deleteDailyListItem({dispatch}, payload) {
      //
      await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc(payload.date).delete()
        .then(() => {
          dispatch('removeItemFromDailyItemsList', { date: payload.date });
        })
        .catch(error => {
          console.log('Error deleting schedule item', error)
        })
    },

  /* ---------------------------------------------------------------- */    
    async removeItemFromDailyItemsList({ commit }, payload) {
      await fb.dailiesCollection.doc(fb.auth.currentUser.uid).collection('dailies').doc('dailieslist').update({ dates: firebase.firestore.FieldValue.arrayRemove(payload.date) })
        .then(() => {
          commit('updateDailyItemsList', { date: payload.date, todo: 'delete' })
        })
        .catch(error => {
          console.log('Error deleting schedule item:', error)
        })
    },

  },

  /* ================================================================ */
  getters: {
    //
  }
}